import memoizeOne from 'memoize-one'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'umi-plugin-react/locale'

import { getPermissionsByStaffId, getPermissionConfig } from '@/services/api'
import { menu } from '../defaultSettings'

// Conversion router to menu.
function formatter(data, permissions, parentName) {
  if (!data) {
    return undefined
  }
  return data
    .map(item => {
      if (!item.name || !item.path) {
        return null
      }

      let locale = 'menu'
      if (parentName && parentName !== '/') {
        locale = `${parentName}.${item.name}`
      } else {
        locale = `menu.${item.name}`
      }
      // if enableMenuLocale use item.name,
      // close menu international
      const name = menu.disableLocal
        ? item.name
        : formatMessage({ id: locale, defaultMessage: item.name })
      // 给路由添加权限配置
      item.authority =
        item.auth || // 如果在 route.config.js 中直接配置了路由有权限，则不根据角色权限配置判断
        !permissions ||
        !permissions.length ||
        permissions.some(permission => permission.id === item.id || permission.pid === item.id)
      const result = {
        ...item,
        name,
        locale,
      }
      if (item.routes) {
        const children = formatter(item.routes, permissions, locale)
        // Reduce memory usage
        result.children = children
      }
      delete result.routes
      return result
    })
    .filter(item => item)
}

const memoizeOneFormatter = memoizeOne(formatter, isEqual)

/**
 * get SubMenu or Item
 */
const getSubMenu = item => {
  // doc: add hideChildrenInMenu
  if (item.children && !item.hideChildrenInMenu && item.children.some(child => child.name)) {
    return {
      ...item,
      children: filterMenuData(item.children), // eslint-disable-line
    }
  }
  return item
}

/**
 * filter menuData
 */
const filterMenuData = menuData => {
  if (!menuData) {
    return []
  }
  return menuData
    .filter(item => item.name && !item.hideInMenu && item.authority)
    .map(item => getSubMenu(item)) // 递归判断子菜单
    .filter(item => item)
}
/**
 * 获取面包屑映射
 * @param {Object} menuData 菜单配置
 */
const getBreadcrumbNameMap = menuData => {
  if (!menuData) {
    return {}
  }
  const routerMap = {}

  const flattenMenuData = data => {
    data.forEach(menuItem => {
      if (menuItem.children) {
        flattenMenuData(menuItem.children)
      }
      // Reduce memory usage
      routerMap[menuItem.path] = menuItem
    })
  }
  flattenMenuData(menuData)
  return routerMap
}

const memoizeOneGetBreadcrumbNameMap = memoizeOne(getBreadcrumbNameMap, isEqual)

export default {
  namespace: 'menu',

  state: {
    menuData: [],
    routerData: [],
    breadcrumbNameMap: {},
  },

  effects: {
    *getMenuData({ payload }, { call, put }) {
      const permissionConfig = yield call(getPermissionConfig) // 获取所有路由配置
      const permissions = yield call(getPermissionsByStaffId) // 获取当前用户的权限
      yield put({
        type: 'user/savePermissions',
        payload: permissions,
      })
      permissions.forEach(permission => {
        const config = permissionConfig.find(item => item.id === permission.id)

        if (config) {
          permission.pid = config.pid
        } else {
          return null
        }
      })

      const { routes, path } = payload
      const originalMenuData = memoizeOneFormatter(routes, permissions, path)
      const menuData = filterMenuData(originalMenuData)
      const breadcrumbNameMap = memoizeOneGetBreadcrumbNameMap(originalMenuData)
      yield put({
        type: 'save',
        payload: { menuData, breadcrumbNameMap, routerData: routes },
      })
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
}
